import type { ReactNode } from 'react'

import { BottomSheet } from 'react-spring-bottom-sheet'

import { bottomSheetMotionProps } from './bottomSheetConfig'

type BottomSheetWrapperProps = {
    open: boolean
    onClose: () => void
    title?: string
    children: ReactNode
    className: string
}

export const BottomSheetWrapper = ({ open, onClose, title, className, children }: BottomSheetWrapperProps) => {
    return (
        <BottomSheet
            className={`bottom-sheet-wrapper max-w-[500px] ${className || ''}`}
            open={open}
            onDismiss={onClose}
            {...bottomSheetMotionProps}
            header={
                title && (
                    <h1 className="flex items-center text-xl justify-center font-bold text-gray-800">
                        {title}
                    </h1>
                )
            }
        >
            <div className="p-4">{children}</div>
        </BottomSheet>
    )
}
